import React from "react"
import { startGame, endGame, updateRoomSettings } from "./justOneRoom"
import { Screen, JoButton, Pill, PlayerDot, C, F } from "./JustOneUI"
import { playSound } from "../../../utils/ballparkSounds"

const LobbyScreen = ({ room, code, isHost }) => {
  const totalRounds = room.totalRounds || 7
  const duration = room.duration || 90

  const players = Object.entries(room.players || {}).sort(
    (a, b) => a[1].joinedAt - b[1].joinedAt
  )

  return (
    <Screen style={{ gap: 20 }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 13, fontWeight: 800, letterSpacing: 2, color: C.muted, fontFamily: F.display }}>
          ROOM CODE
        </div>
        <div style={{ fontFamily: F.display, fontWeight: 900, fontSize: 48, letterSpacing: 2, color: C.cyan }}>
          {code}
        </div>
        <div style={{ fontSize: 13, fontWeight: 700, color: C.muted }}>
          Friends join at <span style={{ color: C.cyan, fontWeight: 800 }}>ryandymock.com/justone</span>
        </div>
      </div>

      <div>
        <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.5, color: C.muted, fontFamily: F.display }}>
          PLAYERS · {players.length}
        </div>
        <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
          {players.map(([pid, p]) => (
            <div
              key={pid}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                background: C.card,
                border: `1.5px solid ${C.border}`,
                borderRadius: 12,
                padding: "10px 14px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
              }}
            >
              <PlayerDot color={p.color} />
              <span style={{ fontWeight: 800, fontSize: 15, color: C.ink }}>{p.name}</span>
              {pid === room.hostId && <Pill style={{ marginLeft: "auto" }}>HOST</Pill>}
            </div>
          ))}
        </div>
      </div>

      <div>
        <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.5, color: C.muted, fontFamily: F.display }}>
          TOTAL ROUNDS
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          {[5, 7, 10, 13].map((n) => (
            <JoButton
              key={n}
              variant={totalRounds === n ? "cyan" : "panel"}
              onClick={() => {
                if (isHost) {
                  playSound("click")
                  updateRoomSettings(code, { totalRounds: n })
                }
              }}
              disabled={!isHost}
              style={{
                height: 44,
                flex: 1,
                cursor: isHost ? "pointer" : "default",
                opacity: !isHost ? (totalRounds === n ? 1 : 0.45) : 1,
              }}
            >
              {n}
            </JoButton>
          ))}
        </div>
      </div>

      <div>
        <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 1.5, color: C.muted, fontFamily: F.display }}>
          ROUND TIMER (OPTIONAL)
        </div>
        <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>
          {[45, 60, 90, 120, 180].map((sec) => (
            <JoButton
              key={sec}
              variant={duration === sec ? "cyan" : "panel"}
              onClick={() => {
                if (isHost) {
                  playSound("click")
                  updateRoomSettings(code, { duration: sec })
                }
              }}
              disabled={!isHost}
              style={{
                height: 44,
                flex: "1 0 50px",
                cursor: isHost ? "pointer" : "default",
                opacity: !isHost ? (duration === sec ? 1 : 0.45) : 1,
                fontSize: 14,
              }}
            >
              {sec}s
            </JoButton>
          ))}
        </div>
      </div>

      <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: 10 }}>
        {isHost ? (
          <>
            <JoButton
              onClick={() => {
                playSound("click")
                startGame(code, { totalRounds, duration })
              }}
              disabled={players.length < 2}
            >
              {players.length < 2 ? "Waiting for players (Min 2)…" : "Start Game"}
            </JoButton>
            <JoButton variant="ghost" onClick={() => endGame(code)}>
              Cancel Game
            </JoButton>
          </>
        ) : (
          <div style={{ textAlign: "center", fontWeight: 700, color: C.muted, fontFamily: F.display, padding: 12 }}>
            Waiting for the host to start…
          </div>
        )}
      </div>
    </Screen>
  )
}

export default LobbyScreen
